module.exports = __webpack_public_path__ + "static/media/arrow-back-finvaro.2e053b7b.svg";